import { OBTAIN_TYPE_HAND_TO_HAND } from './../../prompt/core/enum/obtain-type';

export const isHandDelivery = exchange => exchange.bid && exchange.bid.obtainMethod && exchange.bid.obtainMethod === OBTAIN_TYPE_HAND_TO_HAND ? true : false;

export const hasDelivery = exchange => exchange.deliveryDetails && exchange.deliveryDetails.list && exchange.deliveryDetails.list.length > 0 ? true : false;

export const hasOtherPlatforms = exchange => exchange.usersDetails.map(u => u.trailList.length).reduce((pre, cur) => pre + cur, 0) > 0;

export const hasContactDetails = exchange => exchange.usersDetails.map(u => u.hasContactDetails ? 1 : 0).reduce((pre, cur) => pre + cur, 0) > 0;
